module.exports = __webpack_public_path__ + "img/w73.55deaf4b.svg";